import type { AxiosError } from 'axios';

interface BackendError {
  error?: { message?: string };
}

export function extractErrorMessage(err: unknown, fallback = 'Ocorreu um erro inesperado'): string {
  const e = err as AxiosError<BackendError>;
  return e.response?.data?.error?.message ?? fallback;
}
